import React from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';
import XIcon from '../../../utility/XIcon';

const footerStyles = {
  fillColor: (props) => ({
    background: props.tenant.primary,
    color: 'white',
  }),
};

function ColumnFooters({ classes, year, closeYearClickHandler }) {
  const { t } = useTranslation();

  return (
    <button
      className={['column-bottom-fill', classes.fillColor].join(' ')}
      onClick={() => closeYearClickHandler()}
      type="button"
    >
      <p className="close-year-text">{t('Close Year {{year}}', { year })}</p>
      <XIcon color="#FFFFFF" scrollIntoView={false} />
    </button>
  );
}

export default withStyles(footerStyles)(ColumnFooters);
